class AttachmentFiles {
	constructor(formFilesElement, options = {}) {
		this.formFilesElement = formFilesElement;

		this.fileInputSelector = options.fileInputSelector || '.js-form-files-input';
		this.fileDeleteSelector = options.fileDeleteSelector || '.js-form-file-delete';
		this.fileItemSelector = options.fileItemSelector || '.js-form-file-item';
		this.fileItemListSelector = options.fileItemListSelector || '.js-form-files-list';

		this.fileInputElement = this.formFilesElement.querySelector('input[type="file"]');
		this.fileInputID = this.fileInputElement.id;

        this.accept = this.fileInputElement.accept.replaceAll('.', '').split(',');

		this.renderFunction = options.renderFunction || this._render;

		this._init();
	}

	_init = () => {
		if (this.formFilesElement.classList.contains('init')) return;

		const attachFiles = state.attachFiles;
		let files = null;

		for (let id of Object.keys(attachFiles)) {
			if (id === this.fileInputID) {
				files = attachFiles[id];
			}
		}

		if (!files) {
			this.files = this.fileInputElement.files;

			attachFiles[this.fileInputID] = this.files;
		} else {
			this.files = this.fileInputElement.files = files;

            this.renderFunction(this, this.fileInputElement, Array.from(files));
		}

		this.formFilesElement.addEventListener('change', this._changeInputHandler)
		this.formFilesElement.addEventListener('click', this._deleteFileHandler);

		this.formFilesElement.classList.add('init');
	}

    showError = () => {
        const errorField = this.formFilesElement.querySelector('.form-file__error');

        if (errorField) {
            errorField.classList.remove('hide');
        } else {
            this.formFilesElement.insertAdjacentHTML('beforeend', `
                <span class="form-file__error">Прикрепите файлы до 5 мб. Доступные форматы:  ${this.accept.join(', ')}</span>
            `)
        }
    }

	_changeInputHandler = (e) => {
		const target = e.target.closest(this.fileInputSelector);

		if (target !== this.fileInputElement) return;

		this._addFiles();

		this.renderFunction(this, this.fileInputElement, Array.from(target.files));

        setTimeout(() => {
            this.checkValid();
        }, 1)
	}

	_addFiles = () => {
		const dt = new DataTransfer();
		[...this.files,  ...this.fileInputElement.files].forEach(file => dt.items.add(file))
		this.fileInputElement.files = this.files = state.attachFiles[this.fileInputID] = dt.files;
	}

	_deleteFileHandler = (e) => {
		const target = e.target.closest(this.fileDeleteSelector);

		if (!target) return;

		const fileItem = target.closest(this.fileItemSelector);
		const removedFileId = +fileItem.dataset.id;

		fileItem.remove();

        this.checkValid();

		this._removeFile(removedFileId);
	}

    checkValid = () => {
        const errorEl = this.formFilesElement.querySelector('.form-file__error');

        if (!this.formFilesElement.querySelector('.js-form-file-item.error')) {
            errorEl && errorEl.classList.add('hide');
            this.fileInputElement.classList.add('valid');
        } else {
            errorEl && errorEl.classList.remove('hide');
            this.fileInputElement.classList.remove('valid');
        }

        this.fileInputElement.closest('[data-validate-form]')?.validate.checkValidForm();
    }

	_removeFile = (removedFileId) => {
		const dt = new DataTransfer();
		Array.from(this.fileInputElement.files).forEach(file => {
			if (file.lastModified !== removedFileId) {
				dt.items.add(file);
			}
		})
		this.fileInputElement.files = this.files = state.attachFiles[this.fileInputID] = dt.files;
	}

	_render = (_, inputElement, fileList) => {
		const fileListElement = this.formFilesElement.querySelector(this.fileItemListSelector);

		const html = fileList.map(({name, lastModified, size, type}) => {
            const error = (size / 1024 / 1024 > 5) || ((!this.accept.includes(type.split('/')[1])) && !name.endsWith('.rar'));

            if (error) {
                this.showError();
            }

			return `
				<li class="form-file__item js-form-file-item${error ? ' error' : ''}" data-id="${lastModified}">
					<span class="form-file__name">${name}</span>
					<button class="form-file__delete js-form-file-delete" type="button">
						<svg viewBox="0 0 24 24" width="24" height="24">
							<use xlink:href="#close"></use>
						</svg>
					</button>
				</li>
			`
		}).join('')

		fileListElement.innerHTML = html;
	}
}
